const PHONE_COUNTRY_CODES = {
    af: {
        countryCode: 93,
        ALPHA_3: 'AFG'
    },
    ax: {
        countryCode: 358,
        ALPHA_3: 'ALA'
    },
    al: {
        countryCode: 355,
        ALPHA_3: 'ALB'
    },
    dz: {
        countryCode: 213,
        ALPHA_3: 'DZA'
    },
    as: {
        countryCode: 1684,
        ALPHA_3: 'ASM'
    },
    ad: {
        countryCode: 376,
        ALPHA_3: 'AND'
    },
    ao: {
        countryCode: 244,
        ALPHA_3: 'AGO'
    },
    ai: {
        countryCode: 1264,
        ALPHA_3: 'AIA'
    },
    ag: {
        countryCode: 1268,
        ALPHA_3: 'ATG'
    },
    ar: {
        countryCode: 54,
        ALPHA_3: 'ARG'
    },
    am: {
        countryCode: 374,
        ALPHA_3: 'ARM'
    },
    aw: {
        countryCode: 297,
        ALPHA_3: 'ABW'
    },
    au: {
        countryCode: 61,
        ALPHA_3: 'AUS'
    },
    aq: {
        countryCode: 672,
        ALPHA_3: 'ATA'
    },
    at: {
        countryCode: 43,
        ALPHA_3: 'AUT'
    },
    az: {
        countryCode: 994,
        ALPHA_3: 'AZE'
    },
    bs: {
        countryCode: 1242,
        ALPHA_3: 'BHS'
    },
    bh: {
        countryCode: 973,
        ALPHA_3: 'BHR'
    },
    bd: {
        countryCode: 880,
        ALPHA_3: 'BGD'
    },
    bb: {
        countryCode: 1246,
        ALPHA_3: 'BRB'
    },
    by: {
        countryCode: 375,
        ALPHA_3: 'BLR'
    },
    be: {
        countryCode: 32,
        ALPHA_3: 'BEL'
    },
    bz: {
        countryCode: 501,
        ALPHA_3: 'BLZ'
    },
    bj: {
        countryCode: 229,
        ALPHA_3: 'BEN'
    },
    bm: {
        countryCode: 1441,
        ALPHA_3: 'BMD'
    },
    bt: {
        countryCode: 975,
        ALPHA_3: 'BTN'
    },
    bo: {
        countryCode: 591,
        ALPHA_3: 'BOL'
    },
    ba: {
        countryCode: 387,
        ALPHA_3: 'BIH'
    },
    bw: {
        countryCode: 267,
        ALPHA_3: 'BWA'
    },
    br: {
        countryCode: 55,
        ALPHA_3: 'BRA'
    },
    vg: {
        countryCode: 1284,
        ALPHA_3: 'VGB'
    },
    bn: {
        countryCode: 673,
        ALPHA_3: 'BRN'
    },
    bg: {
        countryCode: 359,
        ALPHA_3: 'BGR'
    },
    bf: {
        countryCode: 226,
        ALPHA_3: 'BFA'
    },
    bi: {
        countryCode: 257,
        ALPHA_3: 'BDI'
    },
    kh: {
        countryCode: 855,
        ALPHA_3: 'KHM'
    },
    cm: {
        countryCode: 237,
        ALPHA_3: 'CMR'
    },
    ca: {
        countryCode: 1,
        ALPHA_3: 'CAN'
    },
    cv: {
        countryCode: 238,
        ALPHA_3: 'CPV'
    },
    bq: {
        countryCode: 599,
        ALPHA_3: 'BES'
    },
    ky: {
        countryCode: 1345,
        ALPHA_3: 'CYM'
    },
    cf: {
        countryCode: 236,
        ALPHA_3: 'CAF'
    },
    td: {
        countryCode: 235,
        ALPHA_3: 'TCD'
    },
    cl: {
        countryCode: 56,
        ALPHA_3: 'CHL'
    },
    cn: {
        countryCode: 86,
        ALPHA_3: 'CHN'
    },
    co: {
        countryCode: 57,
        ALPHA_3: 'COL'
    },
    km: {
        countryCode: 269,
        ALPHA_3: 'COM'
    },
    cg: {
        countryCode: 242,
        ALPHA_3: 'COG'
    },
    ck: {
        countryCode: 682,
        ALPHA_3: 'COK'
    },
    cr: {
        countryCode: 506,
        ALPHA_3: 'CRI'
    },
    hr: {
        countryCode: 385,
        ALPHA_3: 'HRV'
    },
    cu: {
        countryCode: 53,
        ALPHA_3: 'CUB'
    },
    cw: {
        countryCode: 599,
        ALPHA_3: 'CUW'
    },
    cy: {
        countryCode: 357,
        ALPHA_3: 'CYP'
    },
    cz: {
        countryCode: 420,
        ALPHA_3: 'CZE'
    },
    cd: {
        countryCode: 243,
        ALPHA_3: 'COD'
    },
    dk: {
        countryCode: 45,
        ALPHA_3: 'DNK'
    },
    io: {
        countryCode: 246,
        ALPHA_3: 'IOT'
    },
    dj: {
        countryCode: 253,
        ALPHA_3: 'DJI'
    },
    dm: {
        countryCode: 1767,
        ALPHA_3: 'DMA'
    },
    do: {
        countryCode: 1,
        ALPHA_3: 'DOM'
    },
    tl: {
        countryCode: 670,
        ALPHA_3: 'TLS'
    },
    ec: {
        countryCode: 593,
        ALPHA_3: 'ECU'
    },
    eg: {
        countryCode: 20,
        ALPHA_3: 'EGY'
    },
    sv: {
        countryCode: 503,
        ALPHA_3: 'SVL'
    },
    gq: {
        countryCode: 240,
        ALPHA_3: 'GNQ'
    },
    er: {
        countryCode: 291,
        ALPHA_3: 'ERI'
    },
    ee: {
        countryCode: 372,
        ALPHA_3: 'EST'
    },
    et: {
        countryCode: 251,
        ALPHA_3: 'ETH'
    },
    fm: {
        countryCode: 691,
        ALPHA_3: 'FSM'
    },
    fk: {
        countryCode: 500,
        ALPHA_3: 'FLK'
    },
    fo: {
        countryCode: 298,
        ALPHA_3: 'FRO'
    },
    fj: {
        countryCode: 679,
        ALPHA_3: 'FJI'
    },
    fi: {
        countryCode: 358,
        ALPHA_3: 'FIN'
    },
    fr: {
        countryCode: 33,
        ALPHA_3: 'FRA'
    },
    pf: {
        countryCode: 689,
        ALPHA_3: 'PYF'
    },
    ga: {
        countryCode: 241,
        ALPHA_3: 'GAB'
    },
    gm: {
        countryCode: 220,
        ALPHA_3: 'GMB'
    },
    de: {
        countryCode: 49,
        ALPHA_3: 'DEU'
    },
    gh: {
        countryCode: 233,
        ALPHA_3: 'GHA'
    },
    gi: {
        countryCode: 350,
        ALPHA_3: 'GIB'
    },
    gr: {
        countryCode: 30,
        ALPHA_3: 'GRC'
    },
    gl: {
        countryCode: 299,
        ALPHA_3: 'GRL'
    },
    gd: {
        countryCode: 1473,
        ALPHA_3: 'GRD'
    },
    gp: {
        countryCode: 590,
        ALPHA_3: 'GLP'
    },
    gu: {
        countryCode: 1671,
        ALPHA_3: 'GUM'
    },
    gt: {
        countryCode: 502,
        ALPHA_3: 'GTM'
    },
    gf: {
        countryCode: 594,
        ALPHA_3: 'GUF'
    },
    gn: {
        countryCode: 224,
        ALPHA_3: 'GIN'
    },
    gw: {
        countryCode: 245,
        ALPHA_3: 'GNB'
    },
    gy: {
        countryCode: 592,
        ALPHA_3: 'GUY'
    },
    ht: {
        countryCode: 509,
        ALPHA_3: 'HTI'
    },
    hn: {
        countryCode: 504,
        ALPHA_3: 'HND'
    },
    hk: {
        countryCode: 852,
        ALPHA_3: 'HKG'
    },
    hu: {
        countryCode: 36,
        ALPHA_3: 'HUN'
    },
    is: {
        countryCode: 354,
        ALPHA_3: 'ISL'
    },
    in: {
        countryCode: 91,
        ALPHA_3: 'IND'
    },
    id: {
        countryCode: 62,
        ALPHA_3: 'IDN'
    },
    ie: {
        countryCode: 353,
        ALPHA_3: 'IRL'
    },
    im: {
        countryCode: 44,
        ALPHA_3: 'IMN'
    },
    il: {
        countryCode: 972,
        ALPHA_3: 'ISR'
    },
    it: {
        countryCode: 39,
        ALPHA_3: 'ITA'
    },
    ci: {
        countryCode: 225,
        ALPHA_3: 'CIV'
    },
    jm: {
        countryCode: 1876,
        ALPHA_3: 'JAM'
    },
    jp: {
        countryCode: 81,
        ALPHA_3: 'JPN'
    },
    jo: {
        countryCode: 962,
        ALPHA_3: 'JOR'
    },
    kz: {
        countryCode: 7,
        ALPHA_3: 'KAZ'
    },
    ke: {
        countryCode: 254,
        ALPHA_3: 'KEN'
    },
    ki: {
        countryCode: 686,
        ALPHA_3: 'KIR'
    },
    kr: {
        countryCode: 82,
        ALPHA_3: 'KOR'
    },
    kw: {
        countryCode: 965,
        ALPHA_3: 'KWT'
    },
    kg: {
        countryCode: 996,
        ALPHA_3: 'KGZ'
    },
    la: {
        countryCode: 856,
        ALPHA_3: 'LAO'
    },
    lv: {
        countryCode: 371,
        ALPHA_3: 'LVA'
    },
    lb: {
        countryCode: 961,
        ALPHA_3: 'LBN'
    },
    ls: {
        countryCode: 266,
        ALPHA_3: 'LSO'
    },
    lr: {
        countryCode: 231,
        ALPHA_3: 'LBR'
    },
    ly: {
        countryCode: 218,
        ALPHA_3: 'LYB'
    },
    li: {
        countryCode: 423,
        ALPHA_3: 'LIE'
    },
    lt: {
        countryCode: 370,
        ALPHA_3: 'LTU'
    },
    lu: {
        countryCode: 352,
        ALPHA_3: 'LUX'
    },
    mo: {
        countryCode: 853,
        ALPHA_3: 'MAC'
    },
    mg: {
        countryCode: 261,
        ALPHA_3: 'MDG'
    },
    mw: {
        countryCode: 265,
        ALPHA_3: 'MWI'
    },
    my: {
        countryCode: 60,
        ALPHA_3: 'MYS'
    },
    mv: {
        countryCode: 960,
        ALPHA_3: 'MDV'
    },
    ml: {
        countryCode: 223,
        ALPHA_3: 'MLI'
    },
    mt: {
        countryCode: 356,
        ALPHA_3: 'MLT'
    },
    mh: {
        countryCode: 692,
        ALPHA_3: 'MHL'
    },
    mq: {
        countryCode: 596,
        ALPHA_3: 'MTQ'
    },
    mr: {
        countryCode: 222,
        ALPHA_3: 'MRT'
    },
    mu: {
        countryCode: 230,
        ALPHA_3: 'MUS'
    },
    mx: {
        countryCode: 52,
        ALPHA_3: 'MEX'
    },
    md: {
        countryCode: 373,
        ALPHA_3: 'MDA'
    },
    mc: {
        countryCode: 377,
        ALPHA_3: 'MCO'
    },
    mn: {
        countryCode: 976,
        ALPHA_3: 'MNG'
    },
    me: {
        countryCode: 382,
        ALPHA_3: 'MNE'
    },
    ms: {
        countryCode: 1664,
        ALPHA_3: 'MSR'
    },
    ma: {
        countryCode: 212,
        ALPHA_3: 'MAR'
    },
    mz: {
        countryCode: 258,
        ALPHA_3: 'MOZ'
    },
    mm: {
        countryCode: 95,
        ALPHA_3: 'MMR'
    },
    na: {
        countryCode: 264,
        ALPHA_3: 'NAM'
    },
    nr: {
        countryCode: 674,
        ALPHA_3: 'NRU'
    },
    np: {
        countryCode: 977,
        ALPHA_3: 'NPL'
    },
    nl: {
        countryCode: 31,
        ALPHA_3: 'NLD'
    },
    nc: {
        countryCode: 687,
        ALPHA_3: 'NCL'
    },
    nz: {
        countryCode: 64,
        ALPHA_3: 'NZL'
    },
    ni: {
        countryCode: 505,
        ALPHA_3: 'NIC'
    },
    ne: {
        countryCode: 227,
        ALPHA_3: 'NER'
    },
    ng: {
        countryCode: 234,
        ALPHA_3: 'NGA'
    },
    nu: {
        countryCode: 683,
        ALPHA_3: 'NIU'
    },
    nf: {
        countryCode: 672,
        ALPHA_3: 'NFK'
    },
    mp: {
        countryCode: 1670,
        ALPHA_3: 'MNP'
    },
    no: {
        countryCode: 47,
        ALPHA_3: 'NOR'
    },
    om: {
        countryCode: 968,
        ALPHA_3: 'OMN'
    },
    pk: {
        countryCode: 92,
        ALPHA_3: 'PAK'
    },
    pw: {
        countryCode: 680,
        ALPHA_3: 'PLW'
    },
    ps: {
        countryCode: 970,
        ALPHA_3: 'PSE'
    },
    pa: {
        countryCode: 507,
        ALPHA_3: 'PAN'
    },
    pg: {
        countryCode: 675,
        ALPHA_3: 'PNG'
    },
    py: {
        countryCode: 595,
        ALPHA_3: 'PRY'
    },
    pe: {
        countryCode: 51,
        ALPHA_3: 'PER'
    },
    ph: {
        countryCode: 63,
        ALPHA_3: 'PHL'
    },
    pl: {
        countryCode: 48,
        ALPHA_3: 'POL'
    },
    pt: {
        countryCode: 351,
        ALPHA_3: 'PRT'
    },
    pr: {
        countryCode: 1,
        ALPHA_3: 'PRI'
    },
    qa: {
        countryCode: 974,
        ALPHA_3: 'QAT'
    },
    ge: {
        countryCode: 995,
        ALPHA_3: 'GEO'
    },
    mk: {
        countryCode: 389,
        ALPHA_3: 'MKD'
    },
    re: {
        countryCode: 262,
        ALPHA_3: 'REU'
    },
    ro: {
        countryCode: 40,
        ALPHA_3: 'ROU'
    },
    ru: {
        countryCode: 7,
        ALPHA_3: 'RUS'
    },
    rw: {
        countryCode: 250,
        ALPHA_3: 'RWA'
    },
    sh: {
        countryCode: 290,
        ALPHA_3: 'SHN'
    },
    kn: {
        countryCode: 1869,
        ALPHA_3: 'KNA'
    },
    lc: {
        countryCode: 1758,
        ALPHA_3: 'LCA'
    },
    mf: {
        countryCode: 590,
        ALPHA_3: 'MAF'
    },
    vc: {
        countryCode: 1784,
        ALPHA_3: 'VCT'
    },
    ws: {
        countryCode: 685,
        ALPHA_3: 'WSM'
    },
    sm: {
        countryCode: 378,
        ALPHA_3: 'SMR'
    },
    st: {
        countryCode: 239,
        ALPHA_3: 'STP'
    },
    sa: {
        countryCode: 966,
        ALPHA_3: 'SAU'
    },
    sn: {
        countryCode: 221,
        ALPHA_3: 'SEN'
    },
    rs: {
        countryCode: 381,
        ALPHA_3: 'SRB'
    },
    sc: {
        countryCode: 248,
        ALPHA_3: 'SYC'
    },
    sl: {
        countryCode: 232,
        ALPHA_3: 'SLE'
    },
    sg: {
        countryCode: 65,
        ALPHA_3: 'SGP'
    },
    sk: {
        countryCode: 421,
        ALPHA_3: 'SVK'
    },
    si: {
        countryCode: 386,
        ALPHA_3: 'SVN'
    },
    sb: {
        countryCode: 677,
        ALPHA_3: 'SLB'
    },
    za: {
        countryCode: 27,
        ALPHA_3: 'ZAF'
    },
    es: {
        countryCode: 34,
        ALPHA_3: 'ESP'
    },
    lk: {
        countryCode: 94,
        ALPHA_3: 'LKA'
    },
    sd: {
        countryCode: 249,
        ALPHA_3: 'SDN'
    },
    sr: {
        countryCode: 597,
        ALPHA_3: 'SUR'
    },
    sz: {
        countryCode: 268,
        ALPHA_3: 'SWZ'
    },
    se: {
        countryCode: 46,
        ALPHA_3: 'SWE'
    },
    ch: {
        countryCode: 41,
        ALPHA_3: 'CHE'
    },
    tw: {
        countryCode: 886,
        ALPHA_3: 'TWN'
    },
    tj: {
        countryCode: 992,
        ALPHA_3: 'TJK'
    },
    tz: {
        countryCode: 225,
        ALPHA_3: 'TZA'
    },
    th: {
        countryCode: 66,
        ALPHA_3: 'THA'
    },
    tg: {
        countryCode: 228,
        ALPHA_3: 'TGO'
    },
    tk: {
        countryCode: 690,
        ALPHA_3: 'TKL'
    },
    to: {
        countryCode: 676,
        ALPHA_3: 'TON'
    },
    tt: {
        countryCode: 1868,
        ALPHA_3: 'TTO'
    },
    tn: {
        countryCode: 216,
        ALPHA_3: 'TUN'
    },
    tr: {
        countryCode: 90,
        ALPHA_3: 'TUR'
    },
    tm: {
        countryCode: 993,
        ALPHA_3: 'TKM'
    },
    tc: {
        countryCode: 1649,
        ALPHA_3: 'TCA'
    },
    tv: {
        countryCode: 688,
        ALPHA_3: 'TUV'
    },
    ug: {
        countryCode: 256,
        ALPHA_3: 'UGA'
    },
    ua: {
        countryCode: 380,
        ALPHA_3: 'UKR'
    },
    ae: {
        countryCode: 971,
        ALPHA_3: 'ARE'
    },
    gb: {
        countryCode: 44,
        ALPHA_3: 'GBR'
    },
    uy: {
        countryCode: 598,
        ALPHA_3: 'URY'
    },
    vi: {
        countryCode: 1340,
        ALPHA_3: 'VIR'
    },
    us: {
        countryCode: 1,
        ALPHA_3: 'USA'
    },
    uz: {
        countryCode: 998,
        ALPHA_3: 'UZB'
    },
    vu: {
        countryCode: 678,
        ALPHA_3: 'VUT'
    },
    va: {
        countryCode: 39,
        ALPHA_3: 'VAT'
    },
    ve: {
        countryCode: 58,
        ALPHA_3: 'VEN'
    },
    vn: {
        countryCode: 84,
        ALPHA_3: 'VNM'
    },
    wf: {
        countryCode: 681,
        ALPHA_3: 'WLF'
    },
    ye: {
        countryCode: 967,
        ALPHA_3: 'YEM'
    },
    zm: {
        countryCode: 260,
        ALPHA_3: 'ZMB'
    },
    zw: {
        countryCode: 263,
        ALPHA_3: 'ZWE'
    }
};

module.exports = {
    PHONE_COUNTRY_CODES
};
